export default {
  common: {
    clearAll: 'Esborra-ho tot',
    required: 'Obligatori',
    restart: 'Reinicia'
  },
  createUser: {
    acceptTermsAndConditions: 'Accepteu els termes i condicions',
    alreadyHaveAccount: 'Ja tens un compte? %{pre}Descarregar%{post}',
    checkEmail: 'Mentrestant, descarregueu Metrica Play al vostre ordinador',
    clubCompany: 'Organització/Club',
    createdSuccessfully:
      'Inscripció correcta! Comproveu el vostre correu electrònic registrat per obtenir un enllaç de verificació. (Comprova la carpeta de correu brossa)',
    email: 'Correu electrònic',
    invalidEmail: 'Email invàlid',
    job: 'Feina/Rol',
    lastName: 'Cognom',
    name: 'Nom',
    noCustomOption: 'Opció no disponible',
    noMatches: 'Sense coincidències, escriu la teva pròpia opció',
    password: 'Contrasenya',
    passwordsDontMatch: 'Les contrasenyes no coincideixen',
    passwordInvalid: 'La contrasenya no compleix els requisits',
    passwordRequirements: {
      minLength: 'Almenys %{count} caràcters',
      uppercase: 'Una lletra majúscula',
      lowercase: 'Una lletra minúscula',
      number: 'Un número (0-9)',
      maxLength: 'Com a màxim %{count} caràcters'
    },
    phone: 'Telèfon',
    phoneCode: 'País',
    proceed: 'Continuar',
    repeatPassword: 'Repeteix la contrassenya',
    searchPhoneCode: 'Cerca...',
    seeTermsAndConditions: 'Consulta els termes i condicions',
    signAgreement:
      'Registrar-te en un compte de Metrica Sports significa que acceptes la %{pre1}Política de Privacitat%{post1} i els %{pre2}Termes de Servei%{post2}',
    signUpHere: 'Crea el teu compte per començar.',
    sport: 'Esport',
    submitting: 'Començant...',
    title: 'Comença amb %{product}',
    userKeyField: "Tens un codi promocional o una clau d'usuari? Omple aquest camp"
  },
  error: {
    downloadPlay: 'Si ja tens un compte, baixa la darrera versió de Play i inicia sessió.',
    emailTaken: "Aquest correu electrònic ja s'ha pres",
    fieldTooLong: "Alguns camps són massa llargs. Escurça'ls i torna-ho a provar",
    oops: 'Vaja!',
    restart: 'Sembla que estàs intentant fer alguna cosa que encara estem desenvolupant...',
    tryAgain:
      "Si us plau, torna-ho a provar. Si aquest error continua, contacta amb l'equip de suport de Metrica Sports",
    userKey:
      'La clau no és vàlida. Comproveu la vostra clau i torneu-ho a provar o suprimiu el camp per completar el registre'
  },
  invitation: {
    acceptButton: 'Accepto el Canvi del Meu Compte',
    accepting: 'Acceptant...',
    cancelButton: 'Rebutjar',
    description1:
      "Quan siguis afegit al nou compte de Metrica Sports, la propietat del teu compte actual de Metrica Sports (i la informació continguda en ell) serà transferida i assignada al nou propietari del compte de Metrica Sports. Tota la informació i les dades actualment contingudes en el teu compte de Metrica Sports, així com qualsevol informació o dada desada després d'acceptar el canvi de compte, seran visibles i estaran disponibles per al nou propietari del compte de Metrica Sports i per a qualsevol administrador(s) d'aquest compte, per utilitzar-les i compartir-les amb altres a discreció del propietari del compte.",
    description2:
      'En fer clic a "Accepto el canvi del meu compte" acceptes i autoritzes el següent:',
    list1: 'La informació del teu compte actual serà transferida al nou compte de Metrica Sports.',
    list2:
      'Tota la informació del compte transferida al teu nou compte de Metrica Sports des del teu compte actual podrà ser gestionada pel nou propietari del compte i/o administrador(s).',
    list3:
      "En el nou compte de Metrica Sports, el teu rol serà “Membre”. Ja no tindràs privilegis de propietari ni d'administrador del teu compte actual.",
    list4:
      'Heredaràs la configuració existent del teu nou compte de Metrica Sports, que pot ser més o menys restrictiva depenent del teu rol en el compte, i la teva configuració podrà ser gestionada pel nou propietari o administrador(s) del compte de Metrica Sports.',
    list5:
      "La teva configuració actual podrà ser modificada si entra en conflicte amb la configuració del compte nou al qual t'uneixes.",
    list6:
      'És possible que el teu nou compte no proporcioni accés a totes les funcions que tens en el teu compte actual.',
    list7:
      "No és possible revertir la transferència del teu compte una vegada que l'inicies, i tota la teva informació de compte romandrà en un sol compte.",
    list8:
      'En fer clic a "Accepto el Canvi de la Meva Compta", et convertiràs en un membre gestionat del compte de %{pre1}%{email}%{post1} i acceptes els %{pre2}Termes de Servei%{post2} i la %{pre3}Declaració de Privacitat%{post3} de Metrica Sports.',
    subtitle:
      'En acceptar aquesta nova invitació de compte de Metrica Sports, seràs afegit a un altre compte de Metrica Sports.',
    title: 'Invitació'
  },
  jobs: {
    academyDirector: "Director de l'academia",
    assistantCoach: 'Entrenador asistent',
    dataAnalyst: 'Analista de dades',
    doctor: 'Doctor',
    formerPlayer: 'Ex Jugador',
    goalkeeperCoach: 'Entrenador de porters',
    headCoach: 'Entrenador',
    journalist: 'Periodista',
    other: 'Altres',
    performance: 'Rendiment i fitness',
    player: 'Jugador',
    scout: 'Scout',
    sportsDirector: 'Director esportiu',
    student: 'Estudiant',
    videoAnalyst: 'Analista de vídeo'
  },
  sports: {
    americanFootball: 'Futbol americà',
    baseball: 'Beisbol',
    basketball: 'Bàsquet',
    fieldHockey: 'Hoquei sobre gespa',
    football: 'Futbol',
    futsal: 'Futbol sala',
    gaelicFootball: 'Futbol Gaèlic',
    handball: 'Handbol',
    iceHockey: 'Hoquei sobre gel',
    lacrosse: 'Lacrosse',
    netball: 'Netball',
    other: 'Altres',
    padel: 'Pàdel',
    rugby: 'Rugby',
    tennis: 'Tennis',
    volleyball: 'Voleibol'
  }
}
